const initialState= {
  list_declaration:[],
  loading_list:false,
  number:5,

}

export function formReducers(state=initialState,action){
	switch(action.type){
    case 'GET_DECLARATION_LOADING':
    return{
      ...state,
      loading_list:true,

    }

    case 'GET_DECLARATION_SUCCESS':
    return{
      ...state,
      list_declaration:action.payload.declarations,
      loading_list:false,
      number:action.payload.number
    }

    case 'GET_DECLARATION_ERROR':
    return{
      ...state,
      loading_list:false,
    }

    default:
		  return state


    }

}
